const theme = {
  purple: {
    primary: "#a300cc",
    dark: "#8000a1",
  },
  background: "#f7faff",
}

export default theme
